/**
 * Energy Layer Helpers
 *
 * Helper functions for rendering solar potential energy layers on the map.
 */

/**
 * Get solar potential color based on average exposure (kWh/m²/year)
 * Matches the color scheme used in the Building Property Panel Energy Section
 */
export const getSolarPotentialColor = (exposure: number): string => {
  if (exposure >= 1400) return '#A80200' // Excellent - Dark Red
  if (exposure >= 1200) return '#FA5502' // Very Good - Orange-Red
  if (exposure >= 1000) return '#FCAA00' // Good - Orange
  if (exposure >= 800) return '#FFFC09' // Moderate - Yellow
  return '#2DC5FF' // Poor - Light Blue
}

/**
 * Get solar potential label for exposure value
 */
export const getSolarPotentialLabel = (exposure: number): string => {
  if (exposure >= 1400) return 'Excellent'
  if (exposure >= 1200) return 'Very Good'
  if (exposure >= 1000) return 'Good'
  if (exposure >= 800) return 'Moderate'
  return 'Poor'
}

/**
 * Create Mapbox fill expression for solar potential coloring
 * Uses case expression to map average_exposure values to colors
 */
export const createSolarPotentialFillExpression = (): any => {
  return [
    'case',
    ['>=', ['get', 'average_exposure'], 1400],
    '#A80200', // Excellent
    ['>=', ['get', 'average_exposure'], 1200],
    '#FA5502', // Very Good
    ['>=', ['get', 'average_exposure'], 1000],
    '#FCAA00', // Good
    ['>=', ['get', 'average_exposure'], 800],
    '#FFFC09', // Moderate
    '#2DC5FF', // Poor (default)
  ]
}

/**
 * Solar potential color scheme
 */
export const SOLAR_POTENTIAL_COLORS = {
  excellent: '#A80200',
  veryGood: '#FA5502',
  good: '#FCAA00',
  moderate: '#FFFC09',
  poor: '#2DC5FF',
}
